<template>
	<component 
		:is="name" 
		:size="size"
		:class="[`text-${ color }`]"
	/>
</template>

<script>
import bell from 'vue-material-design-icons/Bell'
import bellRing from 'vue-material-design-icons/BellRing'

export default {
	name: 'MaterialIcon',
	components: {
		bell,
		bellRing
	},
	props: {
		name: {
			type: String,
			required: true
		},
		color: {
			type: String,
			default: 'black'
		},
		size: {
			type: [Number, String],
			default: 12
		}
	}
}
</script>